// extracted by mini-css-extract-plugin
export var column = "ServicesItem-module--column--U1e-3";
export var container = "ServicesItem-module--container--P+7B0";
export var container__item = "ServicesItem-module--container__item--wyuWm";
export var container__item__image = "ServicesItem-module--container__item__image--1IR2N";
export var linkWrap = "ServicesItem-module--linkWrap--ikdep";
export var reverse = "ServicesItem-module--reverse--F+tQh";